import React, { useState } from "react";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../common/New-ToolTip";
import UrinaryTractInfection from "../../../../common/tooltip/minor-ailments/urinary-tract-infections";

const UrinaryTractData = () => {
  const [height, setHeight] = useState("");
  return (
    <div className={`${height} transition-all duration-300`}>
      <p className="">
        Urinary tract infection (UTI) is an infection in any part of the urinary
        system. An infection of the bladder is called cystitis; most often caused by
        a bacterial infection.
        <ReactSVG
          src="/icons/information-dark.svg"
          className="w-4 inline-block ml-1"
          data-tooltip-id="urinary-tract-infection"
          onMouseEnter={() => setHeight("h-[200px]")}
          onMouseLeave={() => setHeight("")}
        />
      </p>
      <NewToolTip
        id="urinary-tract-infection"
        render={() => <UrinaryTractInfection />}
      />
    </div>
  );
};

export default UrinaryTractData;
